/**
 * Shared table styling configurations.
 * Use these for consistent StatsTable styling across the application.
 */

/**
 * Standard table styles for StatsTable component.
 * Used for standings, form tables, and statistical displays.
 */
export const tableStyles = {
    borderRadius: "md" as const,
    shadow: "md" as const,
    typography: {
        cell: "text-sm font-medium text-foreground",
        header: "text-xs uppercase font-bold text-muted-foreground",
    },
};

/**
 * Grid styles for StatsGrid component.
 * Used for key metrics and stat cards.
 */
export const gridStyles = {
    item: {
        container: "text-center bg-card border border-border rounded-lg p-4",
        typography: {
            label: "text-sm font-medium text-muted-foreground uppercase",
            value: "text-lg font-bold text-foreground",
            subtitle: "text-xs text-muted-foreground",
        },
    },
};

/**
 * Create grid styles with custom column configuration.
 */
export function createGridStyles(options?: {
    colsMobile?: 1 | 2 | 3 | 4;
    colsTablet?: 1 | 2 | 3 | 4 | 5 | 6;
    colsDesktop?: 1 | 2 | 3 | 4 | 5 | 6;
    gap?: "xs" | "sm" | "md" | "lg";
}) {
    return {
        grid: {
            colsMobile: options?.colsMobile ?? (2 as const),
            colsTablet: options?.colsTablet ?? (3 as const),
            colsDesktop: options?.colsDesktop ?? (3 as const),
            gap: options?.gap ?? ("sm" as const),
        },
        item: gridStyles.item,
    };
}

